import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import ScrollToTop from "@/components/ScrollToTop";
import LangLayout from "@/components/LangLayout";
import Home from "@/pages/Home";
import ThankYou from "@/pages/ThankYou";
import { PrivacyPage, CookiesPage, TermsPage } from "@/pages/Legal";

const LangGuard = ({ children }) => {
  return children;
};

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <ScrollToTop />
        <Routes>
          <Route path="/" element={<Navigate to="/ec" replace />} />
          <Route path="/thank_you" element={<ThankYou />} />

          <Route path="/:lang" element={<LangLayout />}>
            <Route index element={<Home />} />
            <Route path="privacy" element={<PrivacyPage />} />
            <Route path="cookies" element={<CookiesPage />} />
            <Route path="terms" element={<TermsPage />} />
          </Route>

          <Route path="*" element={<Navigate to="/ec" replace />} />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
